<app-loader *ngIf="loader"></app-loader>
<div class="container d-flex align-item-center justify-content-center mt-md-5 visible" id="verify_section">
  <div class="row">
    <div class="card p-4">
      <div class="card-body">
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3" />
        <h5 class="card-title text-light font-weight-bold text-center mt-3">
          VERIFY MOBILE
        </h5>
        <p class="card-text text-center">
          We will send you a one time password on this mobile number 
        </p>
        <form #form_verify="ngForm" class="form_verfiy" id="form_verfigy" name="form_verfigy">
          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Enter 10 digit mobile number" id="phoneNumber" [(ngModel)]="phoneNumber"
              name="phoneNumber" minlength="10" maxlength="10" pattern="\d{10}" required />
              
          </div>
          <!-- <div id="recaptcha-container" class="g-recaptcha"></div> -->
          <div class="form-group">
            <div id="recaptcha-container" class="g-recaptcha" data-callback="verifyRecaptchaCallback"
              data-expired-callback="expiredRecaptchaCallback"></div>
            <input class="form-control d-none" data-recaptcha="true" required
              data-error="Please complete the Captcha" />
            <div class="help-block with-errors"></div>
          </div>

          <div class="opt_btn">
            <button type="button" class="btn btn-danger w-100" (click)="getOtp()">
              GET OTP
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- OTP SECTION -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 hidden" id="otp_section">
  <div class="row">
    <div class="card p-4">
      <div class="card-body">
        <div class="progress">
          <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
        <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3" />
        <h5 class="card-title text-light font-weight-bold text-center mt-3">
          OTP VERIFY
        </h5>
        <p class="card-text text-center">
          We will send you a one time password on this mobile number
        </p>
        <input type="text" class="form-control phone_input" placeholder="{{ phoneNumber }}" type="text"
          [(ngModel)]="phoneNumber" name="phoneNumber" disabled /><a (click)="editNumber()" class="text-danger edit"
          style="cursor: pointer">Edit</a>
        <form #opt_form="ngForm" class="opt_form mt-5" id="opt_form" name="opt_form">
          <div class="row d-flex justify-content-center align-item-center">
            <input id="codeBox1" type="number" maxlength="1" (keyup)="onKeyUpEvent(1, $event)" (focus)="onFocusEvent(1)"
              [(ngModel)]="code1" name="code1" placeholder="-" required />
            <input id="codeBox2" type="number" maxlength="1" (keyup)="onKeyUpEvent(2, $event)" (focus)="onFocusEvent(2)"
              [(ngModel)]="code2" name="code2" placeholder="-" required />
            <input id="codeBox3" type="number" maxlength="1" (keyup)="onKeyUpEvent(3, $event)" (focus)="onFocusEvent(3)"
              [(ngModel)]="code3" name="code3" placeholder="-" required />
            <input id="codeBox4" type="number" maxlength="1" (keyup)="onKeyUpEvent(4, $event)" (focus)="onFocusEvent(4)"
              [(ngModel)]="code4" name="code4" placeholder="-" required />
            <input id="codeBox5" type="number" maxlength="1" (keyup)="onKeyUpEvent(5, $event)" (focus)="onFocusEvent(5)"
              [(ngModel)]="code5" name="code5" placeholder="-" required />
            <input id="codeBox6" type="number" maxlength="1" (keyup)="onKeyUpEvent(6, $event)" (focus)="onFocusEvent(6)"
              [(ngModel)]="code6" name="code6" placeholder="-" required />
          </div>
          <!-- <div id="countdown" class="text-danger font-weight-bold"></div> -->
          <p class="text-right" style="font-size: 12px">
            Don’t get OTP?
            <span id="countdown" class="text-danger font-weight-bold"></span>
            <a id="countdownOpt" class="text-danger font-weight-bold" style="cursor: pointer" (click)="resendOTP()"></a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<!-- <div
  class="modal fade hidden"
  id="modal_unregistered"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modal_unregistered"
  aria-hidden="true"
  #myDiv
>
  <div class="modal-dialog modal-dialog-centered" role="document ">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        >
          <span aria-hidden="true" class="close_span">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <img
          src="../../../assets/img/modalIcon.svg"
          alt="modalIcon"
          class="img-fluid"
        />
        <p class="mt-2">
          Your number is not paired with any Ohm-bot.<br />Please contact
          support and the team shall try to resolve on a priority basis.<br />You
          are important to us.
        </p>
        <div class="verify_btn">
          <a
            href="https://api.whatsapp.com/send?phone=+91-7777067346"
            target="_blank"
            ><button type="button" class="btn btn-danger w-100">
              Click here to contact us
            </button></a
          >
        </div>
      </div>
    </div>
  </div>
</div> -->